import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import ReactAudioPlayer from "react-audio-player";
import Podcasts from "./components/Podcasts";
import Main from "./components/Main";
import Podcast from "./components/Podcast";

// call firebaase functions
// text-to-speech-js
// import textToSpeech from "@google-cloud/text-to-speech";

function App() {
  return (
    <Router>
      <div className="App">
        {/* on time right of screen put page view counter */}

        <header className="App-header">
          <Routes>
            <Route exact path="/" element={<Main />} />
            <Route path="/podcasts" element={<Podcasts />} />
            {/*  podcasts/{podcastID} */}
            <Route path="/podcast/:podcastID" element={<Podcast />} />
            {/* <Route path="/about" component={About} /> */}
          </Routes>
          {/* <p
          className="font-bold text-xs mb-4"
          style={{
            color: "#FF66C4",
          }}
        >
          Powered by ChatGPT
        </p> */}
          <Link to="/">
            <img
              src="/images/logo.png"
              alt="podcast"
              style={{ maxWidth: "90%" }}
              className="absolute top-0 left-0 m-8 w-32 md:w-48 sm:w-42 lg:w-48 xl:w-48"
            />
          </Link>
          {/* <Link to="/podcasts">
            <img
              src="/images/all.png"
              alt="podcast"
              style={{ maxWidth: "90%" }}
              className="absolute top-0 right-0 m-8 w-32 md:w-48 sm:w-48 lg:w-48 xl:w-48"
            />
          </Link> */}

          {/* slowly scrolling horizontal bar with recent searches. resets  */}
        </header>
      </div>
    </Router>
  );
}

export default App;
